import styled from 'styled-components';
import React from 'react';

const SubmitButtonWrapper = styled.div`
  background-color: ${({ theme, Disabled }) => (Disabled ? theme.themeColors.border : theme.themeColors.text)};
  border-radius: 30px;
  cursor: pointer;
  height: 36px;
  width: 36px;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 20px;
    height: 20px;
    fill: ${({ theme }) => theme.themeColors.componentNoOpacity};
  }
`;

export const SubmitButton = ({ onSubmit, Disabled }) => {
  const handleKeyDown = React.useCallback(
    (e) => {
      if (e.target.name === 'question' && e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        onSubmit();
      }
    },
    [onSubmit]
  );

  React.useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleKeyDown]);

  return (
    <SubmitButtonWrapper onClick={onSubmit} Disabled={Disabled}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path d="M13,20H11V8L5.5,13.5L4.08,12.08L12,4.16L19.92,12.08L18.5,13.5L13,8V20Z" />
      </svg>
    </SubmitButtonWrapper>
  );
};
